// extracted by mini-css-extract-plugin
export default {"background":"Hero_background__305Bp","wrapper":"Hero_wrapper__I0-Xe","subsection":"Hero_subsection__VQxDk","img_container":"Hero_img_container__P3S5a"};